<div class="external-paste-warning-dialog">
  <span class="close-btn-container">
    <button
      class="mat-icon-button close-icon"
      (click)="exit()"
      [attr.aria-label]="'APP.PASTE_EXTERNAL_WARNING.CLOSE' | translate"
    >
      <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
        >close</mat-icon
      >
    </button>
  </span>

  <h1 class="heading">{{ 'APP.PASTE_EXTERNAL_WARNING.TITLE' | translate }}</h1>

  <div class="external-paste-warning-title">
    <p>{{ 'APP.PASTE_EXTERNAL_WARNING.MESSAGE_RISK' | translate }}</p>
    <p>{{ 'APP.PASTE_EXTERNAL_WARNING.MESSAGE_PLAIN_TEXT' | translate }}</p>
  </div>
  <div class="external-paste-warning-remember">
    <mat-checkbox
      [checked]="rememberChoice"
      (change)="rememberChoice = $event.checked"
    >
      {{ 'APP.PASTE_EXTERNAL_WARNING.REMEMBER_CHOICE' | translate }}
    </mat-checkbox>
  </div>
  <div class="external-paste-warning-actions">
    <button
      type="button"
      class="wk-button wk-button-text"
      (click)="exit()"
      [attr.aria-label]="'APP.PASTE_EXTERNAL_WARNING.EXIT' | translate"
    >
      {{ 'APP.PASTE_EXTERNAL_WARNING.EXIT' | translate }}
    </button>
    <button
      type="button"
      class="wk-button wk-button-danger"
      (click)="pasteAsPlainText()"
      [attr.aria-label]="
        'APP.PASTE_EXTERNAL_WARNING.PASTE_AS_PLAIN_TEXT' | translate
      "
    >
      {{ 'APP.PASTE_EXTERNAL_WARNING.PASTE_AS_PLAIN_TEXT' | translate }}
    </button>
  </div>
</div>
